/**
 * Recent Orders Component
 * 
 * This component displays a table of recent orders
 * with basic information and actions.
 */

import React from 'react';
import { useApp } from '../../context/AppContext';
import { useTranslations } from '../../context/TranslationsContext';

const RecentOrders = ({ orders, onViewDetails }) => {
  const { translations } = useTranslations();
  const { state } = useApp();
  const t = translations[state.currentLanguage];

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString(state.currentLanguage === 'ar' ? 'ar-SA' : 'en-US');
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat(state.currentLanguage === 'ar' ? 'ar-SA' : 'en-US').format(price);
  };

  const getStatusColor = (status) => {
    const colors = {
      pending: 'bg-yellow-100 text-yellow-800',
      approved: 'bg-blue-100 text-blue-800',
      rejected: 'bg-red-100 text-red-800',
      active: 'bg-green-100 text-green-800',
      completed: 'bg-gray-100 text-gray-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="recent-orders">
      <h3 className="section-title">{t.recentOrders}</h3>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>{t.orderNumber}</th>
              <th>{t.customerName}</th>
              <th>{t.phone}</th>
              <th>{t.price}</th>
              <th>{t.status}</th>
              <th>{t.actions}</th>
            </tr>
          </thead>
          <tbody>
            {orders.slice(0, 10).map(order => (
              <tr key={order.id}>
                <td>#{order.id.substring(0, 8)}</td>
                <td>{order.customer_name}</td>
                <td>{order.customer_phone}</td>
                <td>{formatPrice(order.total_price)} {t.sar}</td>
                <td>
                  <span className={`status-badge ${getStatusColor(order.status)}`}>
                    {t[order.status]}
                  </span>
                </td>
                <td>
                  <button
                    onClick={() => onViewDetails(order)}
                    className="btn-secondary btn-sm"
                  >
                    {t.viewDetails}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentOrders;
